import { Component, Input } from '@angular/core';

@Component({
    selector: 'bz-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
/**
 * LoadingComponent displays a loading spinner with customizable message, size, and theme.
 *
 * @example
 * <bz-loading [message]="'Loading data...'" [size]="'l'" [theme]="'white'"></bz-loading>
 */
export class LoadingComponent {
    /**
     * Message to display below the loader animation.
     * @type {string}
     * @default ''
     */
    @Input() message = '';
    /**
     * Size of the loader. Accepted values: 's' (16px), 'm' (24px), 'l' (32px), 'xl' (64px), 'xxl' (128px).
     * @type {'s' | 'm' | 'l' | 'xl' | 'xxl'}
     * @default 'm'
     */
    @Input() size = 'm';
    /**
     * Loader theme. Use 'beryllium' for white backgrounds (default), or 'white' for colored backgrounds.
     * @type {'beryllium' | 'white'}
     * @default 'beryllium'
     */
    @Input() theme: 'beryllium' | 'white' = 'beryllium';

    getLoaderSvgPath(): string {
        const themeFolder = this.theme === 'white' ? 'White' : 'Beryllium';
        const loaderMap: { [key: string]: string } = {
            xxl: '128px',
            xl: '64px',
            l: '32px',
            m: '24px',
            s: '16px'
        };
        const sizeKey = loaderMap[this.size] || '16px';
        return `assets/icons/loaders/Bizagi_Loader_${sizeKey}_${themeFolder}_SVG.svg`;
    }

    getLoaderSize(): number {
        switch (this.size) {
            case 'xxl':
                return 128;
            case 'xl':
                return 64;
            case 'l':
                return 32;
            case 'm':
                return 24;
            case 's':
            default:
                return 16;
        }
    }
}
